import Hero from "../components/LandingPage/Hero";
import PlansOptions from "../components/LandingPage/PlansOptions";
import PaymentOptions from "../components/LandingPage/PaymentOptions";
import WhyToJoin from "../components/LandingPage/WhyToJoin";
import OrganizationsReviews from "../components/LandingPage/OrganizationsReviews";
import SuccessPartners from "../components/LandingPage/SuccessPartners";
import SafetyAndTerms from "../components/LandingPage/SafetyAndTerms";
import { useGetSubscriptionPlansQuery } from "../services/public/subscriptionPlans";
import Footer from "../components/LandingPage/Footer";
import RequestDemoModal from "../components/Modals/RequestDemoModal";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const hasRequestDemoParam = (searchParams) =>
  searchParams.get("request-demo") === "1";

export default function LandingPage() {
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [openDemoModal, setOpenDemoModal] = useState(() =>
    hasRequestDemoParam(searchParams),
  );

  useEffect(() => {
    if (i18n.language !== "ar") {
      i18n.changeLanguage("ar");
    }
  }, [i18n]);

  useEffect(() => {
    if (!hasRequestDemoParam(searchParams)) return;

    setOpenDemoModal(true);

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("request-demo");
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams]);

  const { data: subscriptionPlans, isLoading, isError } =
    useGetSubscriptionPlansQuery({ locale: "ar" });

  return (
    <>
      {openDemoModal && (
        <RequestDemoModal
          isOpened={openDemoModal}
          onClose={() => setOpenDemoModal(false)}
        />
      )}
      <div className="landing-page">
        <Hero onRequestDemoClick={() => setOpenDemoModal(true)} />
        <div className="landing-page__container">
          <div className="landing-page__spacer landing-page__spacer--sm" />
          <PlansOptions
            subscriptionPlans={subscriptionPlans?.data}
            isLoading={isLoading}
            isError={isError}
          />
          <div className="landing-page__spacer landing-page__spacer--md" />
          <PaymentOptions />
          <div className="landing-page__spacer landing-page__spacer--md" />
          <WhyToJoin />
          <div className="landing-page__spacer landing-page__spacer--md" />
        </div>
        <OrganizationsReviews />
        <div className="landing-page__spacer landing-page__spacer--lg" />
        <SuccessPartners />
        <div className="landing-page__spacer landing-page__spacer--md" />
        <div className="landing-page__container">
          <SafetyAndTerms />
        </div>
        <div className="landing-page__spacer landing-page__spacer--xl" />
        <Footer />
      </div>
    </>
  );
}
